import React, { Component } from "react";
import format from "date-fns/format";
import Modal from "sub_components/Common/PortalModalNew";
import { SuccessMessage, ErrorMessage } from "utils/CommonConstants";
import { StorageApi } from "services/storage";
import { TicketApi } from "services/ticket";
import { TYPES, SEVERITIES } from "utils/TicketConstants";
import { Utils } from "services/utils";
import { BloxButton } from "styled_components/Common/BloxButton";
import WhiteListModal from "../WhiteListModal";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const deleteVipDefault = `${CDN_URL}storage/delete-vip-default-lg.svg`;
const deleteVipSelected = `${CDN_URL}storage/delete-vip-select-lg.svg`;
const deleteVipHover = `${CDN_URL}storage/delete-vip-hover-lg.svg`;

const addVipDefault = `${CDN_URL}storage/add-vip-default-lg.svg`;
const addVipSelected = `${CDN_URL}storage/add-vip-select-lg.svg`;
const addVipHover = `${CDN_URL}storage/add-vip-hover-lg.svg`;

const AtlantaDefault = `${CDN_URL}common/circle-location-ATL-lg.svg`;
const BirminghamDefault = `${CDN_URL}common/circle-location-BHM-lg.svg`;
const ChattanoogaDefault = `${CDN_URL}common/circle-location-CHA-lg.svg`;
const HuntsvilleDefault = `${CDN_URL}common/circle-location-HSV-lg.svg`;
//const LOCATIONS = { 3: 'atlanta', 1: 'birmingham', 2: 'chattanooga', 4: 'huntsville' };
const LOCATIONS = { 1: "birmingham", 2: "chattanooga", 4: "huntsville" };

class VIP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      share: null,
      showText: false,
      showWhiteListModal: false,
      clicked: false,
    };
  }

  getLocationIcon = (id) => {
    if (!id) {
      return null;
    }
    if (LOCATIONS[id] === "atlanta") {
      return AtlantaDefault;
    } else if (LOCATIONS[id] === "birmingham") {
      return BirminghamDefault;
    } else if (LOCATIONS[id] === "chattanooga") {
      return ChattanoogaDefault;
    } else {
      return HuntsvilleDefault;
    }
  };

  onMouseEnter = (id, type) => {
    const icon = document.getElementById(id);
    const { clicked } = this.state;
    const defaultImageDelete = clicked ? deleteVipSelected : deleteVipHover;
    const defaultImageAdd = clicked ? addVipSelected : addVipHover;
    if (type === "Delete") {
      icon.src = defaultImageDelete;
    } else {
      icon.src = defaultImageAdd;
    }
  };
  onMouseLeave = (id, type) => {
    const icon = document.getElementById(id);
    const { clicked } = this.state;
    const defaultImageDelete = clicked ? deleteVipSelected : deleteVipDefault;
    const defaultImageAdd = clicked ? addVipSelected : addVipDefault;

    if (type === "Delete") {
      icon.src = defaultImageDelete;
    } else {
      icon.src = defaultImageAdd;
    }
  };
  showHoverText = () => {
    this.setState({ showText: true });
  };
  hideHoverText = () => {
    this.setState({ showText: false });
  };

  showWhiteListModal = () => {
    const { showWhiteListModal } = this.state;
    this.setState({ showWhiteListModal: !showWhiteListModal });
  };
  formatDescription = (share, auth_status, vip) => {
    const {
      user: { firstname, lastname },
    } = auth_status;
    let description = "";
    description += `Share Name: ${share.common_name}\n `;
    description += `Share ID: ${share?.storage_id}\n `;
    description += `VIP IP: ${vip.vip_address}/${vip.vip_masklen}\n `;
    description += `Requestor: ${firstname}  ${lastname} \n`;

    // Add shared user information if available
    const sharedUserData = sessionStorage.getItem("sharedUser");
    if (sharedUserData) {
      const { name, email } = JSON.parse(sharedUserData);
      description += `Shared User Name: ${name}\n`;
      description += `Shared User Email: ${email}\n`;
    }

    description += `Time: ${format(new Date(), "HH:mm")}`;
    return description;
  };

  createTicket = async (requestType) => {
    const {
      share,
      company_info,
      auth_status,
      vip,
      site,
      auth_status: {
        user: {
          userProfile: { emailAddress },
        },
      },
    } = this.props;

    const type = TYPES.STORAGE;
    const priority = SEVERITIES.LOW;
    const description = this.formatDescription(share, auth_status, vip);
    const title = `${requestType} VIP`;
    const browserInfo = await Utils.getClientParams(site);
    const userId = auth_status.user.id;
    const companyId = company_info?.customer?.id;
    const newTicket = {
      requester: Utils.getRequester(auth_status),
      requester_contact_type: "",
      requester_contact_value: emailAddress,
      internalTicketReference: "",
      requester_id: userId,
      record_id: share?.storage_id,
      invite_id: "",
      public_request: null,
      status: "New",
      title,
      description,
      priority,
      internal_priority: priority,
      type,
      request_type: type,
      request_method: "",
      service: "storage",
      process_id: 0,
      companyId,
      userId,
      jira_ticket: "",
      location: vip?.location_id,
      impact_to_customer: "None",
      impact_to_dcblox: "None",
      resolution_notes: "",
      general_support_question_type: "",
      general_support_question: "",
      general_support_equipment: "",
      feedback_type: "",
      feedback_jira_ticket: "",
      feedback_browser_data: browserInfo,
      billing_detail: [],
      outage_details: [],
      related_tickets: [],
      assignes: [],
      request_log: [],
      comments: [],
      attachments: [],
      notifications: [],
      related_services: [],
      test_results: [],
    };

    TicketApi.createTicket(newTicket)
      .then((response) => {
        sessionStorage.removeItem("tickets");

        console.log(response);
      })
      .catch((error) => console.log(error));
  };

  createVipRequest = (requestType) => {
    const { share, vip, updateShare, orgId, setModalContent, ticketType } =
      this.props;
    const type = requestType === "Delete" ? "disable" : "enable";
    this.setState({ clicked: true });
    setModalContent("CLOSE");
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="storage"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );

    if (ticketType?.bonita) {
      this.createTicket(requestType);
    }
    StorageApi.updateVIPStatus(share?.storage_id, vip?.vip_address, type, orgId)
      .then((response) => {
        if (
          response.status === 200 &&
          !response.data.error &&
          response.data.success
        ) {
          if (updateShare) {
            setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
            updateShare();
            this.setState({ clicked: false });
          }
        } else {
          setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
          this.setState({ clicked: false });
        }
      })
      .catch(() => {
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      });
  };
  showConfirmationModal = (type) => {
    const { setModalContent, vip } = this.props;
    const storages = vip?.storages;
    const button = (
      <BloxButton
        className="buttons41"
        id="confirm-vip-update"
        text="CONTINUE"
        module="storage"
        enabled={true}
        onClick={() => {
          this.createVipRequest(type);
        }}
        cypressId="continue"
      />
    );
    const message = `Changing this VIP affects all containers associated to this VIP : ${storages}`;

    setModalContent("OPEN", message, button);
  };

  render() {
    const { showText, showWhiteListModal, clicked } = this.state;
    const {
      vip,
      index,
      type,
      share,
      shares,
      breakpoint,
      editWhitelist,
      updateVIPsAccess,
      viewWhitelist,
      refreshShare,
      setModalContent,
    } = this.props;
    const defaultImageDelete = clicked ? deleteVipSelected : deleteVipDefault;
    const defaultImageAdd = clicked ? addVipSelected : addVipDefault;

    return (
      <div className="vip-wrapper">
        <div
          className={`vip-details-wrapper ${
            vip?.state === 10 ? "deleted" : ""
          }`}
        >
          {showText && vip?.state !== 2 && (
            <div className="hover-text body10">VIEW VIP DETAILS</div>
          )}
          {showText && vip?.state === 2 && (
            <div className="hover-text body10">INACTIVE</div>
          )}
          <div
            className="vip-details"
            data-cy={`vip-details-${index}`}
            onClick={
              vip?.state !== 2 ? () => this.showWhiteListModal() : () => {}
            }
            onMouseOver={this.showHoverText}
            onMouseOut={this.hideHoverText}
          >
            <div className="location-icon heading90">
              <div className="icon">
                <img src={this.getLocationIcon(vip.location)} />
              </div>
            </div>
            <div className="vip">
              <div className="label heading90">IP</div>
              <div className="value body10">
                {" "}
                {vip.vip_address}
                <span className="slash">/</span>
                {vip.vip_masklen}
              </div>
            </div>
            {vip?.isPrivate && (
              <div className="vlan">
                <div className="label heading90">VLAN</div>
                <div className="value body10"> {vip?.subnet_vlan}</div>
              </div>
            )}
          </div>
          <div className="vip-button-wrapper">
            {vip.state !== 2 && updateVIPsAccess && vip?.state !== 10 && (
              <img
                src={type === "Delete" ? defaultImageDelete : defaultImageAdd}
                id={`vip-${index}${type}`}
                className="vip-button"
                data-cy={`vip-${index}-${type}`}
                onMouseEnter={() =>
                  this.onMouseEnter(`vip-${index}${type}`, type)
                }
                onMouseLeave={() =>
                  this.onMouseLeave(`vip-${index}${type}`, type)
                }
                onClick={() => this.showConfirmationModal(type)}
              />
            )}
            {vip.state === 2 && updateVIPsAccess && vip?.state !== 10 && (
              <img
                src={defaultImageAdd}
                id={`vip-${index}add`}
                className="vip-button"
                data-cy={`vip-${index}-add`}
                onMouseEnter={() => this.onMouseEnter(`vip-${index}add`, "add")}
                onMouseLeave={() => this.onMouseLeave(`vip-${index}add`, "add")}
                onClick={() => this.showConfirmationModal("add")}
              />
            )}
            {/* {vip.status === 2 && <div className='provisioning labels21'>PROVISIONING</div>} */}
            {vip?.state === 10 && (
              <div className="provisioning labels21">DELETED</div>
            )}
          </div>
        </div>
        {showWhiteListModal && (
          <Modal>
            <WhiteListModal
              share={share}
              shares={shares}
              vip={vip}
              showModal={showWhiteListModal}
              closeModal={this.showWhiteListModal}
              breakpoint={breakpoint}
              editWhitelist={editWhitelist}
              viewWhitelist={viewWhitelist}
              refreshShare={refreshShare}
              setModalContent={setModalContent}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export default VIP;
